module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-4-2.v1.jpg";